import { render, staticRenderFns } from "./validar_avance_fisico.vue?vue&type=template&id=61faf3ac&"
import script from "./validar_avance_fisico.vue?vue&type=script&lang=ts&"
export * from "./validar_avance_fisico.vue?vue&type=script&lang=ts&"
import style0 from "./validar_avance_fisico.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports